import * as types from './mutation-types'

export default {
  [types.SET_TESTIMONIALS] (state, obj) {
    state.testimonials = obj
  },
  [types.SET_TESTIMONIAL] (state, obj) {
    state.testimonial = obj
  }
}
